<template>
  <div class="agenda-calendar-skeleton">
    <div class="agenda-calendar-skeleton__main">
      <div class="agenda-calendar-skeleton__toolbar">
        <div class="agenda-calendar-skeleton__block agenda-calendar-skeleton__block--sm"></div>
        <div class="agenda-calendar-skeleton__block agenda-calendar-skeleton__block--md"></div>
        <div class="agenda-calendar-skeleton__block agenda-calendar-skeleton__block--sm"></div>
      </div>
      <div class="agenda-calendar-skeleton__weekdays">
        <span v-for="i in 7" :key="'wd_' + i" class="agenda-calendar-skeleton__weekday"></span>
      </div>
      <div class="agenda-calendar-skeleton__grid">
        <div v-for="i in 35" :key="'cell_' + i" class="agenda-calendar-skeleton__cell"></div>
      </div>
      <div class="agenda-calendar-skeleton__legend">
        <span v-for="i in 4" :key="'leg_' + i" class="agenda-calendar-skeleton__legend-item"></span>
      </div>
      <div class="agenda-calendar-skeleton__notifications">
        <div class="agenda-calendar-skeleton__block agenda-calendar-skeleton__block--notif-title"></div>
        <div v-for="i in 2" :key="'notif_' + i" class="agenda-calendar-skeleton__notif"></div>
      </div>
    </div>
    <div class="agenda-calendar-skeleton__side">
      <div class="agenda-calendar-skeleton__block agenda-calendar-skeleton__block--lg"></div>
      <div v-for="i in 3" :key="'ev_' + i" class="agenda-calendar-skeleton__event"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgendaCalendarSkeleton",
};
</script>

<style lang="scss" scoped src="./agenda-calendar.scss"></style>
